import { render, staticRenderFns } from "./ChatEmotion.vue?vue&type=template&id=9b8d36d4&scoped=true"
import script from "./ChatEmotion.vue?vue&type=script&lang=js"
export * from "./ChatEmotion.vue?vue&type=script&lang=js"
import style0 from "./ChatEmotion.vue?vue&type=style&index=0&id=9b8d36d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8d36d4",
  null
  
)

export default component.exports